<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oUODxI/tc-custom/9781504073332.jpg?1694213174104" alt="This image is the cover for the book Thousand Tiny Disappointments"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Thousand Tiny Disappointments
      </h1>
      <p class="bookDescription body article font2">
        <b>“A thoroughly gripping story about grief [and] unexpected friendship . . . Sarah Edghill knows how to pinpoint what goes on in families.” —Rachel Joyce, author of <i>The Unlikely Pilgrimage of Harold Fry</i></b><br/>  <br/> Martha is being pulled in too many directions, trying to be a good mother, a loving wife, and a dutiful daughter. Despite it all, she’s coping. But then her elderly mother is rushed to the hospital and dies unexpectedly, and the cracks in the life Martha is struggling to hold together are about to be exposed.<br/>  <br/> When she discovers her mother has left her house to a stranger, she’s overwhelmed by grief and hurt. Getting no support from her disinterested husband or arrogant brother, Martha goes on to make some bad decisions.<br/>  <br/> If she were a good daughter, she would abide by her mother’s final wishes. If she were a good daughter, she wouldn’t destroy the evidence . . .<br/><br/> “An accomplished first novel with characters you can relate to, who are struggling with interesting moral dilemmas.” —Katie Fforde, author of <i>A Country Escape</i> and<i> A Wedding in Provence</i><br/><br/> “Compelling and beautifully written, Edghill explores grief, regret and self reconciliation in her debut novel. <i>A Thousand Tiny Disappointments</i> is an accomplished, moving and ultimately uplifting novel about friendship and love.” —Hannah Persaud, author of <i>The Codes of Love</i><br/><br/> “A brilliant story about taking back control of your life. Martha is my new hero. So readable, so relatable.” —Ericka Waller, author of <i>Dog Days</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Edghill
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?272e21ec